module.exports = __webpack_public_path__ + "img/datawise1.481cd22c.png";